/** https map embeds only — same rule as the address-map block. */
export function safeMapEmbedUrl(raw: string): string | undefined {
  const trimmed = raw.trim();
  if (!trimmed) return undefined;
  try {
    const url = new URL(trimmed);
    if (url.protocol !== 'https:') return undefined;
    return url.toString();
  } catch {
    return undefined;
  }
}

export function safeTelHref(raw: string): string | undefined {
  const compact = raw.replace(/[^\d+]/g, '');
  if (!/^\+?[0-9]{6,15}$/.test(compact)) return undefined;
  return `tel:${compact}`;
}

export function safeMailtoHref(raw: string): string | undefined {
  const trimmed = raw.trim();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) return undefined;
  return `mailto:${trimmed}`;
}
